const LOG_PREFIX = '[DiscoverPerf]'

type DiscoverPerfDetails = Record<string, unknown>

let activeSessionId = 0
let sessionStartedAtMs: number | null = null
let sessionLabel = ''
const sessionMarks: Array<{ phase: string; elapsedMs: number; details?: DiscoverPerfDetails }> = []
let summaryLogged = false

function formatDetails(details?: DiscoverPerfDetails): string {
  if (!details || Object.keys(details).length === 0) return ''
  try {
    return ` ${JSON.stringify(details)}`
  } catch {
    return ''
  }
}

export function createDiscoverTraceId(): string {
  return `${Date.now().toString(36)}-${Math.random().toString(36).slice(2, 8)}`
}

export function startDiscoverLoadSession(label: string, details?: DiscoverPerfDetails): number {
  activeSessionId += 1
  sessionStartedAtMs = performance.now()
  sessionLabel = label
  sessionMarks.length = 0
  summaryLogged = false
  console.log(`${LOG_PREFIX} session_start id=${activeSessionId} label=${label}${formatDetails(details)}`)
  return activeSessionId
}

export function markDiscoverLoadPhase(
  phase: string,
  details?: DiscoverPerfDetails,
  options?: { alwaysLog?: boolean }
): void {
  if (sessionStartedAtMs === null) return
  const elapsedMs = Math.round(performance.now() - sessionStartedAtMs)
  const existingIndex = sessionMarks.findIndex((mark) => mark.phase === phase)

  if (existingIndex >= 0 && !options?.alwaysLog) {
    sessionMarks[existingIndex] = { phase, elapsedMs, details }
    return
  }

  if (existingIndex >= 0) {
    sessionMarks[existingIndex] = { phase, elapsedMs, details }
  } else {
    sessionMarks.push({ phase, elapsedMs, details })
  }
  console.log(`${LOG_PREFIX} ${phase} +${elapsedMs}ms${formatDetails(details)}`)
}

export function finishDiscoverLoadPhase(
  phase: string,
  startedAtMs: number,
  details?: DiscoverPerfDetails
): void {
  const phaseMs = Math.round(performance.now() - startedAtMs)
  markDiscoverLoadPhase(phase, { phaseMs, ...details }, { alwaysLog: true })
}

export function summarizeDiscoverLoad(details?: DiscoverPerfDetails): void {
  if (sessionStartedAtMs === null || summaryLogged) return
  summaryLogged = true
  const totalMs = Math.round(performance.now() - sessionStartedAtMs)

  const timedPhases = sessionMarks
    .filter((mark) => typeof mark.details?.phaseMs === 'number')
    .map((mark) => `${mark.phase}=${mark.details!.phaseMs}ms`)

  console.log(
    `${LOG_PREFIX} SUMMARY id=${activeSessionId} label=${sessionLabel} totalMs=${totalMs}` +
      (timedPhases.length ? ` | ${timedPhases.join(' | ')}` : '') +
      formatDetails(details)
  )
}

export function discoverPerfNow(): number {
  return performance.now()
}
